import API from '../api';

export const getUniversities = ({
  params: { page, uuid, page_size } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/universities/universities/${uuid ? uuid : ''}`, { signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

// export const postUniversity = (body) => {
//   return new Promise((resolve, reject) => {
//     try {
//       API.post('/universities/universities', body)
//         .then((res) => {
//           resolve(res?.data);
//         })
//         .catch((err) => {
//           reject('axios error', err);
//         });
//     } catch (error) {
//       reject('system error', error);
//     }
//   });
// };

export const patchUniversity = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      API.patch(`/universities/universities/${uuid}/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getOrganizations = ({ uuid, signal, params } = {}) =>
  API.get(`/universities/organizations/${uuid ? `${uuid}/` : ''}`, { signal, params }).then(
    (response) => response.data,
  );

// Thin variant of patchUniversity: rejects with the real axios error so the
// caller can surface the server message (e.g. the 403 a non-platform admin
// gets when touching the follow-up limits).
export const patchOrganization = (uuid, body, { signal } = {}) =>
  API.patch(`/universities/universities/${uuid}/`, body, { signal }).then(
    (response) => response.data,
  );
